import { render, staticRenderFns } from "./OrderProcessPage.html?vue&type=template&id=7174583c&scoped=true&"
import script from "./OrderProcessPage.js?vue&type=script&lang=js&"
export * from "./OrderProcessPage.js?vue&type=script&lang=js&"
import style0 from "./OrderProcessPage.scss?vue&type=style&index=0&id=7174583c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7174583c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
